<template>
  <div class="reset-password">
    <div class="container-fluid">
      <div
        style="display:flex;justify-content:center;align-items:center; height: 80vh;"
      >
        <div class="confirm-reset-password-page">
          <div class="panel panel-default">
            <div class="text-center">
              <!-- <div style="text-align: center;">
                <img
                  v-if="!forConasi"
                  class="my-4 image-responsive"
                  src="../../assets/e_voucher_logo.svg"
                />
                <img v-else class="my-4 image-responsive" src="../../assets/e_voucher_logo.png">
              </div> -->
              <!-- <div class="line-header">
                </div> -->
              <div class="panel-body">
                <form class="form" ref="form">
                  <div class="title-form">
                    {{ $t("common.changePassword") }}
                  </div>
                  <fieldset>
                    <div class="form-group">
                      <div class="input-group">
                        <label for="inputFullname">{{
                          $t("register.newPassword")
                        }}</label>
                        <div class="input-content">
                          <input
                            id="inputFullname"
                            class="form-control"
                            :type="passwordFieldTypeNew"
                            required=""
                            v-model="newPassword"
                            @keyup.enter="onConfirmResetPassword($event)"
                            v-bind:class="{
                              'form-control': true,
                              'is-invalid':
                                !validate('newPassword') &&
                                fieldBlured.newPassword,
                            }"
                            v-on:blur="fieldBlured.newPassword = true"
                          />
                          <span
                            class="invalid-feedback"
                            style="position: absolute; bottom: -10px; text-align: right;"
                            >{{ errorValidate.newPassword }}</span
                          >
                        </div>
                      </div>
                      <div class="input-group" style="margin-top:10px;">
                        <label for="inputFullname">{{
                          $t("register.confirmPassword")
                        }}</label>
                        <div class="input-content">
                          <input
                            id="emailInput"
                            class="form-control"
                            :type="passwordFieldTypeConfirm"
                            required=""
                            v-model="confirmNewPassword"
                            @keyup.enter="onConfirmResetPassword($event)"
                            v-bind:class="{
                              'form-control': true,
                              'is-invalid':
                                !validate('confirmNewPassword') &&
                                fieldBlured.confirmNewPassword,
                            }"
                            v-on:blur="fieldBlured.confirmNewPassword = true"
                          />
                          <span
                            class="invalid-feedback"
                            style="position: absolute; bottom: -10px; text-align: right;"
                            >{{ errorValidate.confirmNewPassword }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <!-- <input class="btn btn-lg btn-outline-success btn-block" value="Xác nhận" type="submit" @click="onConfirmResetPassword($event)"> -->
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click="onConfirmResetPassword($event)"
                      >
                        {{ $t("common.changePassword") }}
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import functionUtils from 'Utils/functionUtils'
import { FOR_CONASI_TARGET } from 'Utils/constants'
export default {
  data() {
    return {
      passwordFieldTypeNew: "password",
      passwordFieldTypeConfirm: "password",
      newPassword: null,
      oldPassword: null,
      confirmNewPassword: null,
      changeIncon: false,
      InconHidePassword: true,
      forConasi: FOR_CONASI_TARGET,
      errorValidate: {
        newPassword: "",
        confirmNewPassword: "",
      },
      fieldBlured: {
        newPassword: false,
        confirmNewPassword: false,
      },
    };
  },
  methods: {
    validNullOrEmptyString(value) {
      if (value == null || value == undefined || value.length == 0 || value == '') {
        return true
      }
      return false
    },
    validate: function(field) {
      switch (field) {
        case "newPassword":
          if (this.validNullOrEmptyString(this.newPassword)) {
            this.errorValidate.newPassword = this.$t("common.requiredFields");
            return false;
          } else if (!this.validNullOrEmptyString(this.confirmNewPassword) && this.newPassword != this.confirmNewPassword) {
            this.errorValidate.newPassword = this.$t("common.notificationToast.passwordIncorrect");
            return false;
          }
          break;
        case "confirmNewPassword":
          if (this.validNullOrEmptyString(this.confirmNewPassword)) {
            this.errorValidate.confirmNewPassword = this.$t("common.requiredFields");
            return false;
          } else if (!this.validNullOrEmptyString(this.newPassword) && this.newPassword != this.confirmNewPassword) {
            this.errorValidate.confirmNewPassword = this.$t("common.notificationToast.passwordIncorrect");
            return false;
          }
          break;
        default:
          break;
      }
      return true;
    },
    onConfirmResetPassword: function(event) {
      event.preventDefault();
      this.fieldBlured = {
        newPassword: true,
        confirmNewPassword: true
      };
      if (this.validate("newPassword") && this.validate("confirmNewPassword")) {
        let token = this.$route.params.token;
        let uid = this.$route.params.uid;
        let filter = {
          newPassword: this.newPassword,
          confirmPassword: this.confirmNewPassword,
          uidb64: uid,
          token: token,
        };
        this.isLoading = true;
        this.CONFIRM_RESET_PASSWORD(filter)
          .then(
            function() {
              this.isLoading = false;
              this.$toast.clear();
              this.$toast.success(this.$t("common.notificationToast.success"), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              });
              this.$router.push({
                path: "/login",
              });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              this.$toast.clear()
              this.$toast.error(this.$t(functionUtils.errorResponse(error.response)), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            }.bind(this)
          );
      }
    },
    ...mapActions(["CONFIRM_RESET_PASSWORD"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.reset-password {
  background-color: $bg-primary;
  height: 80vh;
  -webkit-animation-name: reset-password;
  animation-name: reset-password;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;

  @-webkit-keyframes container {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes container {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes container {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes reset-password {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  .confirm-reset-password-page {
    width: 33vw;
    height: auto;

    .container {
      display: flex;
      justify-content: center;
      width: 100vw;
      height: 100vh;

      opacity: 0;
      -webkit-animation: container ease-in 1;
      -moz-animation: container ease-in 1;
      animation: container ease-in 1;

      -webkit-animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      animation-fill-mode: forwards;

      -webkit-animation-duration: 1s;
      -moz-animation-duration: 1s;
      animation-duration: 1s;
    }

    .line-header {
      border-top: 1px solid #eee;
      transform: translate(0px, 8vh);
    }

    .panel-body {
      padding: 2rem;
      background-color: #f7fafc;
      font-family: Roboto;
      box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);
      padding: 0 38px 83px 38px;

      .title-form {
        font-size: 18px;
        font-weight: 600;
        padding: 21px 0px 40px 0px;
        text-transform: uppercase;
        text-align: center;
        color: $primary;
      }
      .form-group {
        .input-group {
          display: flex;
          align-items: center;

          .input-group-addon {
            width: 10%;
            font-size: 25px;
            padding: 0px 8px;
            background-color: #eee;
            color: #666;
            border-radius: 5px 0 0 5px;
          }

          label {
            color: $primary;
            font-size: 14px;
          }

          .input-content {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 5px;

            input {
              height: 30px;
              color: $primary !important;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              border: none;
              font-size: 14px;
              margin-bottom: 1rem;

              &:focus {
                box-shadow: none;
                border: 1px solid $primary !important;
                outline: none;
              }
            }

            .btn-show-hiden-password {
              svg {
                margin-right: 10px;
                color: #999;
                font-size: 15px;
                cursor: pointer;
              }
            }
          }
        }

        button {
          width: 100%;
          font-weight: 600;
          background-color: $primary;
          border: none;
          padding: 8px 0;
          margin-top: 15px;

          &:hover {
            background-color: #a55f4a;
          }

          &:focus {
            box-shadow: none;
          }

          &:active {
            background-color: $primary;
          }
        }
      }

      ::-webkit-input-placeholder {
        /* Edge */
        font-size: 14px;
        color: $primary;
      }

      :-ms-input-placeholder {
        /* Internet Explorer */
        font-size: 14px;
        color: $primary;
      }

      ::placeholder {
        font-size: 14px;
        color: $primary;
      }

      input,
      select,
      textarea {
        color: $primary;
      }
    }

    .image-responsive {
      width: 250px;
    }
  }
  @media only screen and (max-width: 1200px) {
    .confirm-reset-password-page {
      width: 70vw;
    }
    .image-responsive {
      width: 200px !important;
    }
  }

  @media only screen and (max-width: 769px) {
    .confirm-reset-password-page {
      width: 90vw;
    }
    .image-responsive {
      width: 180px !important;
    }
  }
}
</style>
